import Vue from 'vue'
import VueI18n, { LocaleMessages } from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages: LocaleMessages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

enum Locale {
  English = "en",
  German = "de",
  Turkish = "tr",
  Bulgarian = "bg",
  Romanian = "ro",
  Russian = "ru",
  French = "fr",
  Ukrainian = "uk",
  Arabic = "ar",
}
export const tenantLocales = {
  "osnabrueck": [Locale.English, Locale.German, Locale.Turkish, Locale.Russian, Locale.French, Locale.Ukrainian, ],
  "berlin": [Locale.English, Locale.German, Locale.Turkish, Locale.Russian, Locale.Arabic, ],
  "gelsenkirchen": [Locale.English, Locale.German, Locale.Turkish, Locale.Bulgarian, Locale.Romanian, Locale.Ukrainian, ],
  "gladbeck": [Locale.English, Locale.German, Locale.Turkish, ], 
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'de',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de',
  messages: loadLocaleMessages()
})
